import { render, staticRenderFns } from "./RegisterSecretQuestion.vue?vue&type=template&id=4902ca8c&scoped=true&"
import script from "./RegisterSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./RegisterSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSecretQuestion.vue?vue&type=style&index=0&id=4902ca8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902ca8c",
  null
  
)

export default component.exports